const UsTvShows = [
    {
      id: 1,
      title: "Stranger Things",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABc3BSoyXIa5jf2tQpI_l6WI11fDoTwYyZI5L3I3pO4-m1xK1xZlgaK6r__GKPwxC0o73jS4ews6PeHNVq1eNCGybZpvG_Gz0GnofhoHu7QGKCXNo9V2Bdp6Z-iO-TQiPHjuS.jpg?r=42a",
    },
    {
      id: 2,
      title: "Lucifer",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABdFmMkQfLjnPnKzK-j0S-5PSWLCoJfVHsDUBQYX2UI8qkIUe_dk-DNSprO6bd7j8zik5vcVWNHQDjGlvXgbuV3yi30Tb7nH1pDzqKwCcubxGfucD5K0t9SKPxqw_6DX12NED.jpg?r=31e",
    },
  
    {
      id: 3,
      title: "The Good Doctor",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABf7QwKjew4DYxRZwR-Z14PY4Sx08O2x4IZnutnSb27uj-IjDRYitUMdQOsnjptz9pXqemv1l1bVLjRDuANVdcluo40A61TCzxI8mJuMco6MXNyT3q-YYpa4Vy8eOjk3T6LCzxqrtNGA4I82pMhfZz1GhBxsjqD7QIxQCheS8i9qUXn1_Z55EDEyUCo7BrrJMDBQfigl8qP96hFJ5T6Fd0Fs7tk8pVL65JXK0J54dX0iuRsOvWhxasOlBMw4jqTccwKwcAL6RR6HJmY1TODLHBNM.jpg?r=1a8",
    },
    {
      id: 4,
      title: "Friends",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABQ6qV_1WV_3a_2gLaQk9MmciQQtSRWKXpkbtbtEhcSQOaWlhkv4YQ8ZlYzL4HGQoebZx-mhqfuZFLCtgWfZOEKTHw_g2IunduRw.jpg?r=75b",
    },
  
    {
      id: 5,
      title: "The Vampire Diaries",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABS6PF8cgxW7MUV3-_IuH2QT9dLo4B3eNVna2TOmGNC_y9Jplr87btjqprRkDM99XiTeXNd3iqe323Vh56DVCoaXg-fa0kq5YW9c.jpg?r=fbe",
    },
    {
      id: 6,
      title: "Breaking Bad",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABdRealouzn4-PlLmziE5wSpIHQUcPj4tT-I4p0Z8ZAyjGFdLHxocesXAtLbZcBqUSQaKwIVdJ6icfGLxDu0SsYZPkMAn5vTJ3vs.jpg?r=01d",
    },
    {
      id: 7,
      title: "Manifest",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABfcVZSb6jykHjD-1NBpoH13AqYGMUODM4VF1-Qj67Y6Sn9ows22AMwNSSkFLEQExc2HB3LXfOoQiFtRLsqhPEM1_ByfKcbXzyRhwgt5QEBVq1rH73Xetwtz5QzirTVR4lGZj.jpg?r=9e9",
    },
    {
      id: 8,
      title: "The Big Bang Theory",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABRpdV2B3rw9C-8Bl1_sz9QQgPIew5G92-8-aC-8O5m4WI-PcMipNFddsBkU_6eyiblyNik4A9-heMe23hEorFtF-sDiUhjL4yiI.jpg?r=bdb",
    },
    {
      id: 9,
      title: "Lost In Space",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABaIitZTDqrvdgk2QItwYWkvfevrH-bX2ufW9ivPXORXpNK6AyYO9v-smewSXbmmHyK2dRipP94GRMkmU6rtZwpxo5e7TAT1kL9nONhZIqRpQOOTFhRCS4KihP8FzIC4rXI2d.jpg?r=0b3",
    },
    {
      id: 10,
      title: "Never Have I Ever",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABSy9_none69cysLlkjhf5IBE-glboqHKHBwJv4tHkL85M7yXn6wn0PvHijBIlxWngR7uaQ3wF-YUnKT412yveUa-foM33hWn2-q7SD80UtAjkD93j7diUmtMg4uPmRtCZ6kI.jpg?r=425",
    },
    {
      id: 11,
      title: "The Walking Dead",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABTCemmEqYOn1oZmvrXY5CuChJt3FXLRxOHcfYmf5G85uC5HtVMvED5i5NqeCfdfqUdSo6qGEjpjtzd4UfrInaobtkTS2I6AG_fo.jpg?r=881",
    },
    {
      id: 12,
      title: "DAHMER",
      img: "https://occ-0-4995-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABcZP-X_jh46H4Lr0o6_8O7yOMUbv_ltLn_8a0eQ62LKTvNxSHmp_4XnGS2K1-Zc6UAGDb7vumap_3uhIQKL_mfxsedkxvOBpuoD20C3TvZM4OEKYdEHKDa_EqlwsMuuohwE8.jpg?r=385",
    },
  ];
  
  
  export default UsTvShows;
  